import React from "react";
import { useEffect, useState, useRef } from "react";

import { connect } from "react-redux";

import Loader from "../../components/Loader";

import {
  setFeaturedDefaultProduct,
  setFeaturedDefaultFalse,
} from "../../redux/actions/products";
import { setAlert } from "../../redux/actions/alerts";

import DeleteForm from "./Forms/DeleteForm";
import Modal from "../Shared/Modal";
import FeaturedTable from "../Shared/FeaturedTable";
import DefaultProductFormRow from "./Forms/DefaultProductFormRow";

const DefaultProductForm = ({
  setAlert,
  setFeaturedDefaultProduct,
  setFeaturedDefaultFalse,
  product: { isLoading, defaultNewProducts },
}) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const [clear, setClear] = useState(0);
  const [selectedContent, setSelectedContent] = useState(null);
  const defaultFeatured = {
    id: null
  }
  const [formValues, setFormValues] = useState([
    defaultFeatured,
    defaultFeatured,
    defaultFeatured,
    defaultFeatured,
  ])

  useEffect(() => {
    if (defaultNewProducts?.length > 0) {
      setFormValues(defaultNewProducts.map(e => ({
        id: e.product_id,
        featuredId: e.product_id,
        name: e.name
      })))
    } else {
      setFormValues([defaultFeatured])
    }
  }, [defaultNewProducts]);

  // const validateFields = () => {
  //   return false
  //   if (
  //     !(
  //       formValues.prod1["id"] &&
  //       formValues.prod2["id"] &&
  //       formValues.prod3["id"] &&
  //       formValues.prod4["id"]
  //     )
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  const processChange = (changingData, i) => {

    let dataToChange = formValues
    dataToChange[i] = {
        ...dataToChange[i],
        ...changingData
    }

    setFormValues([...dataToChange])
  }

  const handleClear = (i) => {
      let dataToChange = formValues

      if (dataToChange[i]?.featuredId) {
          return setSelectedContent(dataToChange[i])
      }
  
      dataToChange.splice(i, 1)
      
      setFormValues([...dataToChange])
  }

  const handleSubmit = async () => {
    // if (validateFields()) {
    //   setAlert("Please fill out all fields below");
    // } else {
      setIsDisabled(true);
      setTimeout(() => {
        setIsDisabled(false);
      }, 3000);
      await setFeaturedDefaultFalse();
      
      // Loops through the formValue state and fires off requests for each product
      // formValues[product][`${product}-select`]  will dynamically grab the specific properties on the formValue obj
      for (const product of formValues) {
        if (product.id) {
          
          setFeaturedDefaultProduct(product.id);

          setClear(prevClear => prevClear + 1)
        }
      }
    // }
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>

     <FeaturedTable
        tableName={'Default Products - New Product Page'}
        
        addButtonName={'New Featured'}
        featuredData={formValues}
        FeaturedForm={DefaultProductFormRow}
        handleSubmit={handleSubmit}
        handleChangeData={processChange}
        defaultFeatured={defaultFeatured}
        setFeaturedData={setFormValues}
        clearFeaturedRow={handleClear}
        clear={clear}
        addedStyles={{maxWidth: '1920px'}}
        disabled={isDisabled}
        setSelectedContent={setSelectedContent}
    />
    <Modal
        open={selectedContent ? true : false}
        setOpen={() => setSelectedContent(null)}
        component={<DeleteForm
            selectedContent={selectedContent}
            updatedData={{
              default_new: false
            }}
            handleClose={() => setSelectedContent(null)}
        />} 

    />
    </>
   
  );
};

const mapStateToProps = (state) => ({
  product: state.product,
});

export default connect(mapStateToProps, {
  setAlert,
  setFeaturedDefaultProduct,
  setFeaturedDefaultFalse,
})(DefaultProductForm);
